<aig-modal class="aig-modal-adddoc" position="center" customMaxWidth="600px">
    <div class="u-p-8 u-pb-3" body>
        <div class="p-flexcc u-dir-col">
            <img src="./assets/images/logos/logo.svg" class="u-mb-3" />
            <div class="p-flecss">
                <p class="u-fs-16 u-color-secondary1 u-mt-def">
                    Selecciona los archivos que deseas adjuntar al siniestro.
                </p>
                <div class="aig-modal-adddoc__documents u-pt-2">
                    <div class="aig-fileupload">
                        <label class="" [class.error]="uploadError">
                            <input type="file" multiple (change)="onFileSelected($event)" hidden #fileInput />
                            <div (drop)="onDrop($event)" (dragover)="onDragOver($event)"
                                class=" aig-modal-adddoc__dragcontainer u-p-def">
                                <i class="icon-open-email aig-modal-adddoc__dragcontainer--icon"></i>
                                <p class="aig-modal-adddoc__dragcontainer--txt">Suelta o selecciona los archivos aquí
                                </p>
                            </div>
                        </label>

                        <div *ngIf="uploadError" class="u-border u-border-warning-error u-radius-4 u-p-def u-my-2">
                            <p class="u-color-warning-error">
                                El archivo '{{ uploadError }}' no se ha cargado correctamente. Inténtalo de nuevo.
                            </p>
                        </div>

                        <div class="u-border u-border-primary1 u-radius-4 u-p-def u-my-2"
                            *ngFor="let file of uploadedFiles">
                            <div class="p-flexcb">
                                <p class="u-color-secondary1">{{ file.name }}</p>
                                <button class="e-btn--secondary p-2" (click)="removeFile(file)"><i
                                        class="icon-trash"></i></button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="u-p-8 u-pt-def u-gap-8 p-flexcc" buttons>
        <button class="e-btn--secondary p-flexcc u-size-per-100" (click)="clickHide()">
            <p class="u-fs-16 u-fw-600">Cancelar</p>
        </button>
        <button class="e-btn--primary p-flexcc u-size-per-100" [disabled]="!uploadedFiles.length || uploadError"
            (click)="save()">
            <p class="u-fs-16 u-fw-600">Guardar</p>
        </button>
    </div>
</aig-modal>


@if(visibleConfirmEditModal){
    <aig-modal-confirm-edit (hideModal)="CloseSaveModal()"></aig-modal-confirm-edit>
    }
